"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getPrefixedValue;
function getPrefixedValue(prefixedValue, value, keepUnprefixed) {
  if (keepUnprefixed) {
    return [prefixedValue, value];
  }
  return prefixedValue;
}
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./~/inline-style-prefixer/utils/getPrefixedValue.js
// module id = 48
// module chunks = 5